export const ENGLISH = 'EN'

export default () => [{ value: ENGLISH, label: 'English' }]
